/**
 * Brand asset contract (slots).
 * Forks replace files under `app/assets/brand/**` and values here;
 * core components must reference these slots, not raw brand paths.
 *
 * Font preload (`?url`) stays in `app.vue` — Nitro cannot resolve Vite
 * query imports from shared `.ts` modules during SSR.
 */
export const brandIcons = {
  logoLargeDark: 'logo:logo-large-dark',
  logoLargeLight: 'logo:logo-large-light',
  logoSmall: 'logo:logo-small',
} as const

export const brandFonts = {
  /** Must match `@font-face` / `@theme` in `fonts.css` + `tokens.css`. */
  family: 'IbmPlex',
  /** Path under `app/` — used by `app.vue` preload import. */
  regularTtf: 'assets/brand/fonts/IbmPlexMono/IBMPlexMono-Regular.ttf',
} as const

export const brandAssets = {
  icons: brandIcons,
  fonts: brandFonts,
} as const

export type BrandIconSlot = (typeof brandIcons)[keyof typeof brandIcons]
